<template lang="pug">
.safety-confirm-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy="isBusy"
    no-border-collapse
    table-class="basic-table nohead-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません。

    // セル：安否確認
    // tableライブラリは使用するが、見た目はtableではないようにする
    template(#cell(safetyConfirm)="row")
      .safety-confirm-row(@click="onColumn(row.item)")
        .d-flex.flex-row.align-items-center.mb-1
          .flex-grow-1
            .date-time.d-flex.align-items-center
              span.date {{ getDate(row.item) }}
              span （
              span.week(:class="weekCssClass(row.item)") {{ getWeek(row.item) }}
              span ）
              span.time {{ getTime(row.item) }}
            .title {{ row.item.name }}
            .status
              span 施設関係者：
              span.sended-non-accepting(v-if="row.item.otherUserMessagesSortKey != null && row.item.acceptingOtherUserReply == true") 受付中
              span.sended-accepting(v-else-if="row.item.otherUserMessagesSortKey != null && row.item.acceptingOtherUserReply == false") 受付停止
              span.non-sended(v-else) 未送信
          .buttons.svg-icon
            .angle-right
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SafetyConfirmsGetModel } from "@/commons/services/SafetyConfirms";

/**
 * ### 安否確認テーブルコンポーネント
 */
@Component({})
export default class SafetyConfirmTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SafetyConfirmTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SafetyConfirmTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isBusy!: boolean;

  get _value(): Array<SafetyConfirmTableItem> {
    return this.value;
  }

  /**
   * ### 日付(yyyy年mm月dd日)を返す
   * */
  public getDate(item: SafetyConfirmTableItem): string {
    return this.$dateUtil.convertNumberToString(item.created, "yyyy年mm月dd日");
  }

  /**
   * ### 曜日を返す
   */
  public getWeek(item: SafetyConfirmTableItem): string {
    const dateObject: Date = this.$dateUtil.convertNumberToDate(item.created);
    return this.$dateUtil.getWeekName(dateObject, "ja");
  }

  /**
   * ### 時分を返す
   */
  public getTime(item: SafetyConfirmTableItem): string {
    return this.$dateUtil.convertNumberToString(item.created, "hh:MM");
  }

  /**
   * ### 曜日の文字色CssClassの割り当て
   */
  public weekCssClass(item: SafetyConfirmTableItem): string {
    let weekClassName: string = "";
    const weekName: string = this.getWeek(item);
    switch (weekName) {
      case "日":
        weekClassName = "sunday";
        break;
      case "土":
        weekClassName = "saturday";
        break;
      default:
        break;
    }

    return weekClassName;
  }

  /**
   * ### 行押下イベント
   */
  public onColumn(item: SafetyConfirmTableItem): void {
    if (item.otherUserMessagesSortKey == null) {
      this.$emit("onRegister", item);
    } else {
      this.$emit("onDetail", item);
    }

    return;
  }
}

/** テーブルの列名の情報 */
export interface SafetyConfirmTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SafetyConfirmTableItem extends SafetyConfirmsGetModel {}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

.safety-confirm-table-component {
  .svg-icon {
    width: 16px;
    height: 16px;
    margin-left: -6px;
    .angle-right {
      @include svg-icon("../../../assets/angle-right.svg", $font-base, 18px, 18px);
    }
  }

  .sunday {
    color: $font-sunday;
  }
  .saturday {
    color: $font-saturday;
  }

  .title {
    font-weight: bold;
  }

  .status {
    .sended-non-accepting,
    .sended-accepting,
    .non-sended {
      font-weight: bold;
    }
    .non-sended {
      color: $font-strong;
    }
  }
}
</style>
